

(function (window) {
  'use strict';

  var isLoginRedirecting = false;
  var loginRedirectStartedAt = 0;


  var LOGIN_REDIRECT_STALE_MS = 15000;
  var LOGIN_REDIRECT_RELEASE_MS = 5000;
  var LOGIN_REQUEST_TIMEOUT_MS = 12000;


  function beginLoginRedirect() {
    isLoginRedirecting = true;
    loginRedirectStartedAt = Date.now();
  }

  function endLoginRedirect() {
    isLoginRedirecting = false;
    loginRedirectStartedAt = 0;
  }


  function isLoginRedirectInProgress() {
    if (!isLoginRedirecting) {
      return false;
    }


    if (Date.now() - loginRedirectStartedAt < LOGIN_REDIRECT_STALE_MS) {
      return true;
    }

    endLoginRedirect();
    return false;
  }


  function releaseLoginRedirectAfterNavigation() {
    if (typeof window.setTimeout !== 'function') {
      return;
    }

    window.setTimeout(endLoginRedirect, LOGIN_REDIRECT_RELEASE_MS);
  }

  function withTimeout(promise, timeoutMs) {
    if (
      typeof window.setTimeout !== 'function' ||
      typeof window.clearTimeout !== 'function'
    ) {
      return promise;
    }

    return new Promise(function (resolve, reject) {
      var timer = window.setTimeout(function () {
        reject(new Error('timed out after ' + timeoutMs + 'ms'));
      }, timeoutMs);

      promise.then(
        function (value) {
          window.clearTimeout(timer);
          resolve(value);
        },
        function (err) {
          window.clearTimeout(timer);
          reject(err);
        }
      );
    });
  }


  var SSO_CONFIG = {
    endpoints: {
      passportBase: 'https://my.realsee.ai',
      proxyBase: 'https://i-shopify-app.realsee.ai',
      loginPageUrl: 'https://login.realsee.ai/shopify',
      logoutPageUrl: 'https://my.realsee.ai/logout'
    },
    auth: {
      source: 'SSO_HOME_APP'
    },
    cookies: {
      realseeToken: 'realsee_token',
      shopifyEssential: '_shopify_essential'
    }
  };




  function getCookie(name) {
    console.log(
      `[Cookie] 尝试读取: ${name}, 当前域名: ${window.location.hostname}`
    );
    console.log(
      `[Cookie] document.cookie 长度: ${document.cookie ? document.cookie.length : 0}`
    );


    const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + escapedName + '=([^;]*)')
    );

    if (match) {
      const value = decodeURIComponent(match[1]);
      console.log(
        `[Cookie] ✓ 成功读取 ${name}:`,
        value.substring(0, 40) + (value.length > 40 ? '...' : '')
      );
      return value;
    }


    console.log('[Cookie] 当前页面所有 cookies:');
    if (document.cookie) {
      const allCookies = document.cookie.split(';').map((c) => c.trim());
      allCookies.forEach((cookie) => {
        if (
          cookie.toLowerCase().includes('token') ||
          cookie.toLowerCase().includes('realsee') ||
          cookie.toLowerCase().includes('auth') ||
          cookie.toLowerCase().includes('session')
        ) {
          console.log(
            `   → ${cookie.substring(0, 90)}${cookie.length > 90 ? '...' : ''}`
          );
        }
      });
    } else {
      console.log('   → document.cookie 为空');
    }

    console.warn(
      `[Cookie] ✗ 未找到 cookie: ${name} (当前域名可能无法访问该cookie)`
    );
    return null;
  }


  function deleteCookie(name) {
    var expired = 'expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    var hostname = window.location.hostname;


    document.cookie = name + '=; ' + expired + '; domain=' + hostname;

    var parts = hostname.split('.');
    if (parts.length > 2) {
      var rootDomain = '.' + parts.slice(-2).join('.');
      document.cookie = name + '=; ' + expired + '; domain=' + rootDomain;
    }

    document.cookie = name + '=; ' + expired;
  }

  function getShopifyLogoutUrl() {
    var shopifyOrigin =
      window.YGSSOConfig && window.YGSSOConfig.shopifyOrigin
        ? window.YGSSOConfig.shopifyOrigin
        : window.location.origin;
    var returnTarget = window.RealseeUtmFlow
      ? window.RealseeUtmFlow.getSafeRedirectUrl()
      : window.location.href;
    var returnUrl = encodeURIComponent(returnTarget);

    return (
      shopifyOrigin.replace(/\/$/, '') +
      '/account/logout?return_url=' +
      returnUrl
    );
  }

  function redirectToUnifiedLogout() {
    var redirectParam = encodeURIComponent(getShopifyLogoutUrl());
    window.location.href =
      SSO_CONFIG.endpoints.logoutPageUrl + '?redirect=' + redirectParam;
  }




  async function getTicket() {
    try {
      console.log('请求了 getToken ===>');
      var accessToken = await window.RealseeAuth.getToken();
      console.log('accessToken===>', accessToken);
      var signedHeaders = await window.RealseeAuth.getAuthHeaders();
      console.log('signedHeaders===>', signedHeaders);
      var res = await fetch(
        SSO_CONFIG.endpoints.proxyBase +
          '/api/proxy/passport/api/v1/session/apply/ticket/page?source=SSO_HOME_APP',
        {
          method: 'POST',
          credentials: 'include',
          headers: Object.assign({}, signedHeaders, {
            Authorization: accessToken,
            Accept: '*/*'
          })
        }
      );

      console.log('getTicket res===>', res);
      console.log('getTicket res.ok===>', res.ok);

      if (!res.ok) {
        console.warn('[YG SSO] getTicket failed, status:', res.status);
        return null;
      }

      var data = await res.json();
      console.log('getTicket data===>', data);
      if (data.code === 0 && data.data && data.data.ticket) {
        return data.data.ticket;
      }
      console.warn('[YG SSO] getTicket unexpected response:', data);
      return null;
    } catch (err) {
      console.warn('[YG SSO] getTicket error:', err);
      return null;
    }
  }


  async function redirectToLoginWithTicket(redirectTargetUrl) {
    if (isLoginRedirectInProgress()) {
      return true;
    }

    beginLoginRedirect();

    try {
      var ticket = await withTimeout(getTicket(), LOGIN_REQUEST_TIMEOUT_MS);
      if (!ticket) {
        console.warn('[YG SSO] getTicket failed, abort login redirect');
        endLoginRedirect();
        return false;
      }

      var redirectTarget = redirectTargetUrl || window.location.href;
      var redirectUrl = encodeURIComponent(
        window.RealseeUtmFlow
          ? window.RealseeUtmFlow.getSafeRedirectUrl(redirectTarget)
          : redirectTarget
      );

      var loginUrl =
        SSO_CONFIG.endpoints.loginPageUrl +
        '?source=' +
        SSO_CONFIG.auth.source +
        '&source_verify=' +
        encodeURIComponent(ticket) +
        '&region=' +
        '&redirect=' +
        redirectUrl;

      console.log('=====loginUrl=====', loginUrl);
      window.location.href = loginUrl;
      releaseLoginRedirectAfterNavigation();
      return true;
    } catch (err) {
      console.warn('[YG SSO] redirectToLoginWithTicket error:', err);
      endLoginRedirect();
      return false;
    }
  }


  async function redirectToLogoutThenShopifyLogout() {
    if (isLoginRedirectInProgress()) {
      return false;
    }

    beginLoginRedirect();

    try {
      var logoutThenShopifyLogoutUrl =
        SSO_CONFIG.endpoints.logoutPageUrl +
        '?redirect=' +
        encodeURIComponent(getShopifyLogoutUrl());
      console.log(
        '[YG SSO] redirectToLogoutThenShopifyLogout url:',
        logoutThenShopifyLogoutUrl
      );
      window.location.href = logoutThenShopifyLogoutUrl;
      releaseLoginRedirectAfterNavigation();
      return true;
    } catch (err) {
      console.warn('[YG SSO] redirectToLogoutThenShopifyLogout error:', err);
      endLoginRedirect();
      return false;
    }
  }


  function getCheckoutRedirectTarget(form, trigger) {
    if (trigger && trigger.tagName === 'A') {
      return trigger.href;
    }

    if (form && form.action) {
      var formPath = new URL(form.action, window.location.href).pathname.replace(/\/+$/, '');

      if (formPath === (Shopify.routes.root + 'cart').replace(/\/+$/, '')) {
        return Shopify.routes.root + 'checkout';
      }
    }

    return undefined;
  }


  async function getRealseeUserId(shopifyCustomerId) {
    if (!shopifyCustomerId) {
      return null;
    }

    try {
      var customerGid =
        String(shopifyCustomerId).indexOf('gid://shopify/Customer/') === 0
          ? String(shopifyCustomerId)
          : 'gid://shopify/Customer/' + String(shopifyCustomerId);
      var accessToken = await window.RealseeAuth.getToken();
      var signedHeaders = await window.RealseeAuth.getAuthHeaders();
      var res = await fetch(
        SSO_CONFIG.endpoints.proxyBase +
          '/api/customer/query?user_id=' +
          encodeURIComponent(customerGid),
        {
          method: 'GET',
          credentials: 'include',
          headers: Object.assign({}, signedHeaders, {
            Authorization: accessToken,
            Accept: '*/*'
          })
        }
      );

      if (!res.ok) {
        console.warn('[YG SSO] getRealseeUserId failed, status:', res.status);
        return null;
      }

      var data = await res.json();
      var realseeUserId =
        data &&
        data.code === 0 &&
        data.data &&
        (data.data.user_id != null || data.data.multipass_identifier != null)
          ? String(
              data.data.user_id != null
                ? data.data.user_id
                : data.data.multipass_identifier
            )
          : '';

      if (!realseeUserId) {
        console.warn('[YG SSO] getRealseeUserId: missing user_id in response');
        return null;
      }

      return realseeUserId;
    } catch (err) {
      console.warn('[YG SSO] getRealseeUserId error:', err);
      return null;
    }
  }


  async function verifyCurrentLoginUser(userId) {
    if (!userId) {
      return 'unknown';
    }

    console.log('[YG SSO] 开始请求了===>userId', userId);

    try {
      var verifyUrl =
        'https://login.realsee.ai/open/v1/verify/user' +
        '?user_id=' +
        encodeURIComponent(userId);
      console.log('[YG SSO] verifyCurrentLoginUser request:', {
        userId: String(userId),
        url: verifyUrl,
        credentials: 'include'
      });

      var res = await fetch(verifyUrl, {
        method: 'GET',
        credentials: 'include',
        headers: {
          Accept: '*/*'
        }
      });
      console.log('[YG SSO] verifyCurrentLoginUser response status:', {
        ok: res.ok,
        status: res.status,
        statusText: res.statusText
      });

      if (!res.ok) {
        if (res.status === 401 || res.status === 403) {
          console.warn(
            '[YG SSO] verifyCurrentLoginUser judged as invalid by status:',
            res.status
          );
          return 'invalid';
        }

        console.warn(
          '[YG SSO] verifyCurrentLoginUser unexpected status:',
          res.status
        );
        return 'unknown';
      }

      var data = await res.json();
      console.log('[YG SSO] verifyCurrentLoginUser response payload:', data);




      if (data && data.data && typeof data.data.is_login === 'boolean') {
        var statusByIsLogin = data.data.is_login ? 'valid' : 'invalid';
        console.log(
          '[YG SSO] verifyCurrentLoginUser judged by data.is_login:',
          {
            is_login: data.data.is_login,
            status: statusByIsLogin
          }
        );
        return statusByIsLogin;
      }


      if (data && data.data && typeof data.data.valid === 'boolean') {
        var statusByValid = data.data.valid ? 'valid' : 'invalid';
        console.log('[YG SSO] verifyCurrentLoginUser judged by data.valid:', {
          valid: data.data.valid,
          status: statusByValid
        });
        return statusByValid;
      }

      if (data && typeof data.success === 'boolean') {
        var statusBySuccess = data.success ? 'valid' : 'invalid';
        console.log('[YG SSO] verifyCurrentLoginUser judged by success:', {
          success: data.success,
          status: statusBySuccess
        });
        return statusBySuccess;
      }

      if (data && typeof data.code === 'number') {
        if (data.code === 0) {
          console.log(
            '[YG SSO] verifyCurrentLoginUser judged by code=0 as valid'
          );
          return 'valid';
        }

        if (data.code === 100000) {
          console.warn(
            '[YG SSO] verifyCurrentLoginUser code=100000 without login field, fallback to unknown'
          );
          return 'unknown';
        }
        console.warn(
          '[YG SSO] verifyCurrentLoginUser judged as invalid by code:',
          data.code
        );
        return 'invalid';
      }

      console.warn(
        '[YG SSO] verifyCurrentLoginUser unknown response structure:',
        data
      );
      return 'unknown';
    } catch (err) {
      console.warn('[YG SSO] verifyCurrentLoginUser error:', err);
      return 'unknown';
    }
  }




  function handleLogout(e) {
    e.preventDefault();
    redirectToUnifiedLogout();
  }


  async function handleLogin(e, redirectTargetUrl) {
    e.preventDefault();
    var redirected = await redirectToLoginWithTicket(redirectTargetUrl);
    if (!redirected) {
      window.alert('SSO login initialization failed. Please try again.');
    }
  }

  function disableEarlyCheckoutGuard() {
    if (
      window.YGSSOEarlyCheckoutGuard &&
      typeof window.YGSSOEarlyCheckoutGuard.disable === 'function'
    ) {
      window.YGSSOEarlyCheckoutGuard.disable();
    }
  }

  function reportTelemetryUserInfo(userId) {
    if (
      !userId ||
      !window.RealseeShopTelemetry ||
      typeof window.RealseeShopTelemetry.setUserId !== 'function'
    ) {
      return;
    }

    window.RealseeShopTelemetry.setUserId(String(userId));
  }

  function bindCheckoutToSSOLogin(config) {
    if (config.isLoggedIn) {
      disableEarlyCheckoutGuard();
      return;
    }


    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || form.tagName !== 'FORM') return;

        var submitter = event.submitter;
        if (!submitter) return;

        var submitterName = (
          submitter.getAttribute('name') || ''
        ).toLowerCase();
        if (submitterName !== 'checkout') return;

        handleLogin(event, getCheckoutRedirectTarget(form, submitter));
      },
      true
    );


    document.addEventListener(
      'click',
      function (event) {
        var trigger = event.target.closest(
          'a[href$="/checkout"], a[href*="/checkout?"], button[name="checkout"], input[name="checkout"]'
        );

        if (!trigger) return;


        if (
          trigger.closest(
            '.additional-checkout-buttons, .shopify-payment-button'
          )
        ) {
          return;
        }

        handleLogin(event, getCheckoutRedirectTarget(null, trigger));
      },
      true
    );


    disableEarlyCheckoutGuard();
  }


  async function initScenario4() {
    var config = window.YGSSOConfig || {};
    var shopifyCustomerId =
      config.customer && config.customer.id != null ? config.customer.id : null;
    console.log('[YG SSO] Scenario 4 start:', {
      isLoggedIn: !!config.isLoggedIn,
      shopifyCustomerId: shopifyCustomerId
    });

    if (!shopifyCustomerId) {
      console.warn(
        '[YG SSO] Scenario 4 skipped because shopify customer id is missing'
      );
      return;
    }

    var realseeUserId = await getRealseeUserId(shopifyCustomerId);
    console.log('[YG SSO] Scenario 4 customer mapping result:', {
      shopifyCustomerId: shopifyCustomerId,
      realseeUserId: realseeUserId
    });
    if (!realseeUserId) {
      console.warn('[YG SSO] Scenario 4 skipped because user_id query failed');
      return;
    }

    reportTelemetryUserInfo(realseeUserId);

    console.log('[YG SSO] 开始请求了===>realseeUserId', realseeUserId);

    var verifyStatus = await verifyCurrentLoginUser(realseeUserId);
    console.log('[YG SSO] Scenario 4 verify result:', {
      realseeUserId: realseeUserId,
      verifyStatus: verifyStatus
    });
    if (verifyStatus === 'invalid') {
      console.warn(
        '[YG SSO] Scenario 4: is_login=false, redirecting to logout then /account/logout'
      );
      var redirectedByLogout = await redirectToLogoutThenShopifyLogout();
      if (!redirectedByLogout) {
        console.warn('[YG SSO] Scenario 4: logout redirect was not triggered');
      }
      return;
    }

    if (verifyStatus === 'unknown') {
      console.warn(
        '[YG SSO] Scenario 4: verify unknown, redirecting to login with ticket'
      );
      var redirected = await redirectToLoginWithTicket();
      if (!redirected) {
        console.warn(
          '[YG SSO] Scenario 4: login redirect was not triggered after verify failure'
        );
      }
      return;
    }
  }



  window.YGSSOLogin = window.YGSSOLogin || {};
  window.YGSSOLogin.triggerLogin = redirectToLoginWithTicket;


  // Returning from the login page via the back button restores the page from the
  // back-forward cache with this module's state intact, so the in-flight latch
  // must be cleared or every login trigger stays dead until a hard reload.
  if (typeof window.addEventListener === 'function') {
    window.addEventListener('pageshow', function (event) {
      if (event && event.persisted) {
        endLoginRedirect();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var config = window.YGSSOConfig || {};


    if (config.isLoggedIn) {
      initScenario4();
    }

    bindCheckoutToSSOLogin(config);


    var authTriggers = document.querySelectorAll('[data-yg-action]');
    if (!authTriggers.length) return;

    authTriggers.forEach(function (trigger) {
      if (trigger.dataset.ygAction === 'login') {
        trigger.addEventListener('click', handleLogin);
      } else if (trigger.dataset.ygAction === 'logout') {
        trigger.addEventListener('click', handleLogout);
      }
    });
  });
})(window);
